import { ConfirmModal, useConfirmModal, useToast } from '@practium/ui';
import { useCancelPlan } from '@practium/features/api';
import { formatDate } from '../../utils/formatMyPlan';
import styles from './CancelPlanCard.module.css';

interface CancelPlanCardProps {
	planName: string;
	expiresIn?: string | null;
	waitCancel?: boolean;
}

export const CancelPlanCard = ({ planName, expiresIn, waitCancel }: CancelPlanCardProps) => {
	const toast = useToast();
	const { mutateAsync: cancelPlan, isPending } = useCancelPlan();
	const { confirm, isOpen, options, handleConfirm, handleCancel } = useConfirmModal();
	const until = formatDate(expiresIn);

	const copy = waitCancel
		? `O cancelamento já foi solicitado. Você continua com o ${planName} até ${until} e não haverá nova cobrança.`
		: `Você continua com o ${planName} até ${until} e não haverá nova cobrança. Seus laudos e o diário de campo ficam guardados por 90 dias caso queira voltar.`;

	const handleClick = async () => {
		const confirmed = await confirm({
			title: 'Cancelar assinatura',
			message: `Tem certeza que deseja cancelar o plano ${planName}? Você mantém o acesso até ${until}.`,
			confirmText: 'Cancelar assinatura',
			cancelText: 'Voltar',
			variant: 'danger',
		});
		if (!confirmed) return;

		try {
			await cancelPlan();
			toast.success('Assinatura cancelada. Você mantém o acesso até o fim do ciclo.');
		} catch (error) {
			toast.error(error instanceof Error ? error.message : 'Não foi possível cancelar a assinatura.');
		}
	};

	return (
		<section className={styles.card}>
			<div className={styles.row}>
				<div className={styles.copy}>
					<h3 className={styles.title}>Cancelar assinatura</h3>
					<p className={styles.text}>{copy}</p>
				</div>
				{waitCancel ? null : (
					<button
						type="button"
						className={styles.button}
						onClick={handleClick}
						disabled={isPending}
					>
						Cancelar Assinatura
					</button>
				)}
			</div>
			<ConfirmModal
				isOpen={isOpen}
				title={options.title}
				message={options.message}
				confirmText={options.confirmText}
				cancelText={options.cancelText}
				variant={options.variant}
				onConfirm={handleConfirm}
				onCancel={handleCancel}
			/>
		</section>
	);
};
